import api from "./axios";

export const listChats = () => api.get("/chats");

export const createChat = (title) => api.post("/chats", { title });

export const getChat = (chatId) => api.get(`/chats/${chatId}`);

export const updateChat = (chatId, title) => api.put(`/chats/${chatId}`, { title });

export const deleteChat = (chatId) => api.delete(`/chats/${chatId}`);

export const sendMessage = (chatId, content, fileIds, mode) =>
  api.post(`/chats/${chatId}/messages`, { content, file_ids: fileIds, mode });

export const getMessages = (chatId) => api.get(`/chats/${chatId}/messages`);

export const shareChat = (chatId) => api.post(`/chats/${chatId}/share`);

export const unshareChat = (chatId) => api.delete(`/chats/${chatId}/share`);

export const getSharedChat = (token) => api.get(`/shared/${token}`);

export const streamMessage = (chatId, content, fileIds, mode) => {
  const token = localStorage.getItem("access_token");
  const base = process.env.REACT_APP_API_URL || "/api";
  return fetch(`${base}/chats/${chatId}/messages/stream`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    credentials: "include",
    body: JSON.stringify({ content, file_ids: fileIds, mode }),
  });
};
